import { CAMPAIGN_ACTION } from '../../../constants/actions'
import { CAMPAIGN_TYPE_OPTIONS } from '../../../util/campaign.helpers'
import { mergeToNewObject } from '../../../util/object.helpers'
import { buildErrorMessage } from '../../../util/reducer.helpers'

export const campaignProfile = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case CAMPAIGN_ACTION.CHANGE_STATE:
      return mergeToNewObject(state, {
        [payload.property]: payload.value,
        ...(payload.property === CAMPAIGN_PROFILE_DISPATCH.VALUE_TEMP && {
          error: {
            ...state.error,
            valueTemp: null
          }
        }),
        ...(payload.property === CAMPAIGN_PROFILE_DISPATCH.TYPE_TEMP &&
          payload.value === CAMPAIGN_TYPE_OPTIONS.UNIQUE && {
            error: {
              ...state.error,
              supplyTemp: null
            }
          })
      })

    case CAMPAIGN_ACTION.ON_CREATE_CAMPAIGN:
      return mergeToNewObject(state, {
        isProcessing: true,
        saveSuccess: false
      })

    case CAMPAIGN_ACTION.ON_CREATE_CAMPAIGN_SUCCESS:
      return mergeToNewObject(state, {
        isProcessing: false,
        saveSuccess: true
      })

    case CAMPAIGN_ACTION.ON_CREATE_CAMPAIGN_FAILED:
      return mergeToNewObject(state, {
        isProcessing: false,
        error: {
          nameTemp: buildErrorMessage(payload)
        },
        saveSuccess: false
      })

    case CAMPAIGN_ACTION.ON_UPDATE_CAMPAIGN:
      return mergeToNewObject(state, {
        isProcessing: true,
        saveSuccess: false
      })

    case CAMPAIGN_ACTION.ON_UPDATE_CAMPAIGN_SUCCESS:
      return mergeToNewObject(state, {
        isProcessing: false,
        saveSuccess: true
      })

    case CAMPAIGN_ACTION.ON_UPDATE_CAMPAIGN_FAILED:
      return mergeToNewObject(state, {
        isProcessing: false,
        saveSuccess: false
      })

    case CAMPAIGN_ACTION.RESET_STATE:
      return INITIAL_STATE

    default:
      return state
  }
}

const INITIAL_STATE = {
  error: '',
  isProcessing: false,

  saveSuccess: false,

  nameTemp: '',
  valueTemp: '',
  supplyTemp: '',
  typeTemp: '',
  validUntilTemp: ''
}

export const CAMPAIGN_PROFILE_DISPATCH = {
  ERROR: 'error',
  NAME_TEMP: 'nameTemp',
  VALUE_TEMP: 'valueTemp',
  SUPPLY_TEMP: 'supplyTemp',
  TYPE_TEMP: 'typeTemp',
  VALID_UNTIL_TEMP: 'validUntilTemp'
}
